import React from 'react';
import styled from 'styled-components';
import firm from '../img/firm.svg';
import logo from '../img/logo.svg';
import ContanierDefault from './Container';

const HeaderStyle = styled.header`
    position: sticky;
    top: 0px;
    grid-area: Header;
    font-size: 1rem;
    background-color: white;
    box-shadow: 0 0 1em rgba(0, 0, 0, 0.1);
    z-index: 2;
`;
const Container = ContanierDefault.extend`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const Logo = styled.img`
    height: 3em;
    width: 4em;

    @media (min-width: 800px) {
        height: 5em;
        width: 7em;
    }
`;
const Home = styled.div`
    display: flex;
    padding: 1em 0;
    text-decoration: none;
`;
const ClaimWithClaim = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 1em;
`;
const Firm = styled.img`
    margin: 0;
    margin-top: 0.3em;
    height: 1.5em;
    width: 7em;

    @media (min-width: 800px) {
        margin-top: 0.9em;
        height: 2em;
        width: 9em;
    }
`;
const Claim = styled.h2`
    color: ${props => props.theme.gray};
    font-size: 0.8em;
    margin: 0;
    @media (min-width: 800px) {
        font-size: 1em;
    }
`;

const Header = () => (
    <HeaderStyle>
        <Container>
            <Home>
                <Logo src={logo} alt="Logo" />
                <ClaimWithClaim>
                    <Firm src={firm} alt="V-Sponse" />
                    <Claim>Differentiate yourself</Claim>
                </ClaimWithClaim>
            </Home>
        </Container>
    </HeaderStyle>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.tsx